import logo from './logo.svg';
import './App.css';
import Temp from './components/weather/Temp'

function App() {
  return (
    <div className="App">
      <Temp />
    </div>
  );
}

export default App;
